<template>
	<div />
</template>

<script>
import { Inertia } from "@inertiajs/inertia";

export default {
	created() {
		if (this.$inertia.page.props.needsStorageCrearing) {
			sessionStorage.clear();
		}
	},
};
</script>
